/**
 * Determine if the state contains errors
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasErrors = state => Object.keys(state.errors).length > 0

export default {
    hasErrors
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/sensitivity-analysis/getters.js